import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Entries from './pages/Entries';
import Settings from './pages/Settings';
import SocialMedia from './pages/SocialMedia';
import Users from './pages/Users';
import Chats from './pages/Chats';
import Messages from './pages/Messages';
import SalesPipeline from './pages/SalesPipeline';
import Topics from './pages/Topics';
import ProspectingSetup from './pages/ProspectingSetup';
import EmailIntegration from './pages/EmailIntegration';


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <PrivateRoute>
                  <Customers />
                </PrivateRoute>
              }
            />
            <Route
              path="/entries"
              element={
                <PrivateRoute>
                  <Entries />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route
              path="/social"
              element={
                <PrivateRoute>
                  <SocialMedia />
                </PrivateRoute>
              }
            />
            <Route
              path="/chats"
              element={
                <PrivateRoute>
                  <Chats />
                </PrivateRoute>
              }
            />
            <Route
              path="/messages"
              element={
                <PrivateRoute>
                  <Messages />
                </PrivateRoute>
              }
            />


            <Route
              path="/sales-pipeline"
              element={
                <PrivateRoute>
                  <SalesPipeline />
                </PrivateRoute>
              }
            />
            <Route
              path="/topics"
              element={
                <PrivateRoute>
                  <Topics />
                </PrivateRoute>
              }
            />
            <Route
              path="/prospecting"
              element={
                <PrivateRoute>
                  <ProspectingSetup />
                </PrivateRoute>
              }
            />
            <Route
              path="/email-integration"
              element={
                <PrivateRoute>
                  <EmailIntegration />
                </PrivateRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;